<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content hotels">
			<hotels :button="defaults[locale].website.book" :items="hotelsData" />
			<div class="fine-bg-pattern" />
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: hotelsData } = await useWebsiteFetch('hotels', {
	query: { language: locale.value },
	key: `${locale.value}/hotels`,
});
</script>

<style lang="scss" scoped>
.hotels {
	background: var(--primary-background-color);
	position: relative;
	padding: 50px 0;
}

.fine-bg-pattern {
	position: absolute;
	inset: 0;
	width: 100%;
	z-index: 1;
	opacity: 0.9;
}
</style>
